exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.phonepreview {\n  background-position: center top;\n  margin-top: 10px;\n}\n", ""]);

